import React from 'react';
import './contact.css';
import HeaderSocials from './HeaderSocials';

const Contact = () => {
	return (
		<section
			className='contact container section'
			id='contact'
		>
			<h2 className='section__title'>Get In Touch</h2>

			<div className='contact__container '>
				<div className='contact__info'>
					<h3 className='contact__title'>Let's talk about everything!</h3>
					<p className='contact__details'>
						View my{' '}
						<a
							href='./Lumapac_Resume.pdf'
							target='_blank'
							rel='noreferrer'
						>
							resume
						</a>
						, or contact me below 👇
					</p>
					<HeaderSocials />
				</div>
			</div>

			<div className='contact__footer'>
				<span className='copyright'>
					Designed and coded with <small>♥</small> by Argie Lumapac © 2025
				</span>
			</div>
		</section>
	);
};

export default Contact;
